import type { StaticEntityType } from "@config";
import { PdfEmbeddedContent } from "@library/components/pdf";
import type { AttachmentProps } from "../types";
import { handleAttachment } from "../utils";

export const AttachmentPdf = ({ entity }: { entity: StaticEntityType }) => {
  const { settings } = entity as StaticEntityType<AttachmentProps>;
  const { url } = handleAttachment({ settings });
  return (
    <PdfEmbeddedContent
      type="attachment"
      url={url}
      shape={settings.shape}
      width={settings.width + "%"}
      height={settings.height}
      horizontalAlignment={settings.horizontalAlignment}
    />
  );
};
